<template lang="pug">
	div.app.flex-row.align-items-center
		div.container
			b-row.justify-content-center
				b-col(md="6")
					div.clearfix
						h1.float-left.display-3.mr-4 404
						h4.pt-3 Oops! You're lost.
						p.text-muted
							| Страница не найдена. Попробуйте
							|
							| начать с
							|
							router-link(to="/") главной страницы
</template>

<script>
export default {
  name: 'Page404'
}
</script>
